module.exports = __webpack_public_path__ + "static/media/_SendToAdvisorModal.d0b9392b.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/SendToAdvisorModal/_SendToAdvisorModal.scss
// module id = 561
// module chunks = 0